import brand from "../config/brand";

// Supabase is not used; auth is handled by the configured Worker.
// This stub prevents crashes from any remaining import references.
const supabase = {
  auth: {
    signInWithPassword: async () => ({
      data: null,
      error: new Error(`Use ${brand.casinoName} auth`),
    }),
    signUp: async () => ({
      data: null,
      error: new Error(`Use ${brand.casinoName} auth`),
    }),
    signInWithOAuth: async () => ({
      data: null,
      error: new Error(`Use ${brand.casinoName} auth`),
    }),
    signOut: async () => ({ error: null }),
    getUser: async () => ({ data: { user: null }, error: null }),
    updateUser: async () => ({ data: null, error: null }),
    onAuthStateChange: () => ({
      data: { subscription: { unsubscribe: () => {} } },
    }),
  },
};

export default supabase;
